import linkResolver from './link-resolver.js';
import { htmlSerializer } from '@swegaming-ab/nuxtjs-helpers';

export default function (type, element, content, children) {
    return htmlSerializer(linkResolver, type, element, content, children);
}